module.exports = __webpack_public_path__ + "static/media/zeya_walking_with_grandmum.4dcd092b.png";